document.addEventListener('scroll', () => {
  const bar = document.querySelector('.reading-progress');
  const el = document.querySelector('.bf-article');
  if (!bar || !el) return;
  const rectTop = el.getBoundingClientRect().top + window.scrollY;
  const max = el.offsetHeight - window.innerHeight;
  const y = Math.max(0, Math.min(max, window.scrollY - rectTop));
  const pct = (y / max) * 100;
  bar.style.setProperty('--progress', pct + '%');
});
